module.exports = __webpack_public_path__ + "static/media/donde_pagar.72899e79.svg";